import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)


const VueRouterPush = Router.prototype.push

Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default new Router({
  routes: [

    {
      path: '/',
      name: 'loginKS', //考生登录界面
      component: () => import('@/components/common/loginKS')
    },
    {
      path: '/admin',
      name: 'login', //后台登录界面
      component: () => import('@/components/common/login')
    },
    {
      path: '/index', //教师主页
      component: () => import('@/components/admin/index'),
      children: [
        {
          path: '/', //首页默认路由
          component: () => import('@/components/common/hello')
        },
        {
          path: '/grade', //学生成绩
          component: () => import('@/components/charts/grade')
        },
        {
          path: '/selectExamToPart', //学生分数段
          component: () => import('@/components/teacher/selectExamToPart')
        },
        {
          path: '/scorePart',
          component: () => import('@/components/charts/scorePart')
        },
        {
          path: '/allStudentsGradeTheory', //所有理论成绩统计
          component: () => import('@/components/teacher/allStudentsGradeTheory')
        },
        {
          path: '/allStudentsGradeSkills', //所有技能成绩统计
          component: () => import('@/components/teacher/allStudentsGradeSkills')
        },
        {
          path: '/selectExam', //查询所有考试
          component: () => import('@/components/teacher/selectExam')
        },
        {
          path: '/addExam', //添加考试
          component: () => import('@/components/teacher/addExam')
        },
        {
          path: '/libraryManage', //题库管理（职业管理）理论题库
          component: () => import('@/components/teacher/libraryManage')
        },
        {
          path: '/libraryManageDetails', //题库管理（工种管理）理论题库
          component: () => import('@/components/teacher/libraryManageDetails')
        },
        {
          path: '/professionLevelList', //职业等级管理 理论题库
          component: () => import('@/components/teacher/professionLevelList')
        },
        {
          path: '/questionTypesList', //题目类型管理 理论题库
          component: () => import('@/components/teacher/questionTypesList')
        },
        {
          path: '/questionBankList', //题目类型下的题库管理 理论题库
          component: () => import('@/components/teacher/questionBankList')
        },

        {
          path: '/libraryManageJN', //题库管理（职业管理）技能题库
          component: () => import('@/components/teacher/libraryManageJN')
        },
        {
          path: '/libraryManageDetailsJN', //题库管理（工种管理）技能题库
          component: () => import('@/components/teacher/libraryManageDetailsJN')
        },
        {
          path: '/professionLevelListJN', //职业等级管理 技能题库
          component: () => import('@/components/teacher/professionLevelListJN')
        },
        {
          path: '/questionTypesListJN', //题目类型管理 技能题库
          component: () => import('@/components/teacher/questionTypesListJN')
        },
        {
          path: '/questionBankListJN', //题目类型下的题库管理 技能题库
          component: () => import('@/components/teacher/questionBankListJN')
        },
        {
          path: '/assessmentContent', //考核内容
          component: () => import('@/components/teacher/assessmentContent')
        },
        {
          path: '/assessmentKeyPoints', //考核要点
          component: () => import('@/components/teacher/assessmentKeyPoints')
        },
        {
          path: '/scoringCriteria', //考核内容
          component: () => import('@/components/teacher/scoringCriteria')
        },
        {
          path: '/preparationAssistiveDevices', //辅具准备
          component: () => import('@/components/teacher/preparationAssistiveDevices')
        },
        {
          path: '/selectAnswer', //查询所有题库
          component: () => import('@/components/teacher/selectAnswer')
        },
        {
          path: '/addAnswer', //增加题库主界面
          component: () => import('@/components/teacher/addAnswer')
        },
        {
          path: '/editAnswerChildren', //编辑题库主界面
          component: () => import('@/components/teacher/editAnswerChildren')
        },
        {
          path: '/addAnswerChildren', //点击试卷跳转到添加题库页面
          component: () => import('@/components/teacher/addAnswerChildren')
        },
        {
          path: '/studentManage', //学生管理界面
          component: () => import('@/components/teacher/studentManage')
        },
        {
          path: '/addStudent', //添加学生
          component: () => import('@/components/teacher/addStudent')
        },
        {
          path: '/teacherManage',
          component: () => import('@/components/admin/tacherManage')
        },
        {
          path: '/addTeacher',
          component: () => import ('@/components/admin/addTeacher')
        },
        {
          path: '/setting',
          component: () => import ('@/components/teacher/setting')
        },
        {
          path: '/weight',
          component: () => import ('@/components/teacher/weight')
        },
        {
          path: '/annotation',
          component: () => import ('@/components/teacher/annotation')
        },
        {
          path: '/annotationUpdateJ',
          component: () => import ('@/components/teacher/annotationUpdateJ')
        },
        {
          path: '/annotationUpdateL',
          component: () => import ('@/components/teacher/annotationUpdateL')
        },
        {
          path: '/annotationL',
          component: () => import ('@/components/teacher/annotationL')
        }
      ]
    },
    {
      path: '/indexTeacher', //教师主页
      component: () => import('@/components/admin/indexTeacher'),
      children: [
        {
          path: '/', //首页默认路由
          component: () => import('@/components/common/hello')
        },
        {
          path: '/allStudentsGradeTeacher', //所有学生成绩统计
          component: () => import('@/components/teacher/allStudentsGradeTeacher')
        },
        ,
        {
          path: '/annotationTeacher',
          component: () => import ('@/components/teacher/annotationTeacher')
        }
      ]
    },
    {
      path: '/ks',
      component: () => import('@/components/ks/index'),
      children: [

        {path: "/", component: () => import('@/components/ks/components/index')},
        {path: "/ksxx", component: () => import('@/components/ks/components/ksxx')},
        {path: "/selectPaper", component: () => import('@/components/ks/components/selectPaper')},
        {path: '/startExam', component: () => import('@/components/student/startExam')},
        {path: '/manager', component: () => import('@/components/student/manager')},
        {path: '/examMsg', component: () => import('@/components/student/examMsg')},
        {path: '/message', component: () => import('@/components/student/message')},
        {path: '/studentScore', component: () => import("@/components/student/answerScore")},
        {path: '/scoreTable', component: () => import("@/components/student/scoreTable")}
      ]
    },
    {path: '/answer', component: () => import('@/components/student/answer')},
    {path: '/st', component: () => import('@/components/ks/components/answer')},
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js